import { useIntl } from 'react-intl';

import { Header } from '~/eds/src/components/Header/Header';
import { Nullable } from '~/types/Nullable';

import { PromptModelPublishStatus } from '../../../../redux/api/types/sylvanus/model';
import { FieldModel } from '../types';
import { getFieldModelHeader } from '../utils';

interface Props {
  fieldModel: FieldModel;
  publishStatus: Nullable<PromptModelPublishStatus>;
}
export const FieldModelTitle = ({ publishStatus, fieldModel }: Props) => {
  const intl = useIntl();
  const header = getFieldModelHeader({
    model: {
      ...fieldModel,
      publishStatus,
    },
    intl,
  });

  return <Header {...header} enablePadding={false} />;
};
